import * as Models from "../.";
export interface IDocusignEnvelope {
        documentType: Models.DocumentManagement.SolarDocumentType.SolarDocumentType;
        remoteEnvelopeId: string;
        epcCalculation: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
        active: boolean;
        inPerson: boolean;
        expirationDate: Date;
    }

    export class DocusignEnvelope implements IDocusignEnvelope {
        documentType: Models.DocumentManagement.SolarDocumentType.SolarDocumentType;
        remoteEnvelopeId: string;
        epcCalculation: Models.CostCalculation.EpcCalculation.IEpcCalculationResult;
        active: boolean;
        inPerson: boolean;
        expirationDate: Date;
    }